<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -agua-para-todos">
      <h2>Agua para todos</h2>
      <h1>El proyecto</h1>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.aguaparatodos')">Agua para todos</router-link>
        <router-link :to="$t('enlaces.aguaparatodos')">El proyecto</router-link>
      </nav>
    </section>

    <main>

      <div class="container">

        <h2 class="title-intro">
          <img src="/static/img/logo-agua-para-todos.png" alt="Logo agua para todos">
        </h2>

        <p class="texto-intro">
          La Fundación Tomás Pascual y Pilar Gómez-Cuétara también financia desde 2018 proyectos de mejora de acceso al
          agua potable para poblaciones desfavorecidas.
        </p>

      </div>


      <section class="white-box objetivo-agua-para-todos">
        <div class="container row-start">
          <h2 class="big-title">Objetivo</h2>
        </div>
        <div class="title-container row-end">
          <h3 class="title-destacado -azul">Llevar agua a aquellos<br>que más lo necesitan en el mundo. Construyendo
            pozos de agua, sistemas de recolección o depósitos.</h3>
        </div>
        <img src="/static/img/grifo.svg" class="grifo">
      </section>

      <section class="alcance">

        <div class="container">
          <h2 class="big-title right">Alcance</h2>
          <div class="top">
            <h2>Acceso a Agua Potable para más de <strong>50.000</strong> personas en África, América y Asia.</h2>
          </div>
          <mapAgua> </mapAgua>
        </div>

      </section>

      <section class="proyectos-sec">
        <div class="container row-end">
          <h2 class="big-title">Proyectos</h2>
        </div>
        <div class="top container">
          <h2><strong>50.000</strong> beneficiados en más de <strong>50</strong> actuaciones en <strong>16</strong> países</h2>
          <div class="table">

            <div class="tr">
              <div class="td">
                <p class="title">Proyecto</p>
              </div>
              <div class="td">
                <p class="title">ONG</p>
              </div>
              <div class="td">
                <p class="title">Lugar</p>
              </div>
              <div class="td">
                <p class="title">Año</p>
              </div>
              <div class="td">
                <p class="title">Beneficiados</p>
              </div>
            </div>
             <div class="tr">
              <div class="td">
                <p>Compra e instalación de 30 tanques de agua en TONITZUL</p>
              </div>
              <div class="td">
                <p>Auara/Jóvenes y Desarrollo</p>
              </div>
              <div class="td">
                <p>Guatemala</p>
              </div>
              <div class="td">
                <p>2024</p>
              </div>
              <div class="td">
                <p>150</p>
              </div>
            </div>
            <div class="tr">
              <div class="td">
                <p>Compra e  instalación de bomba solar en TANGANSIFT</p>
              </div>
              <div class="td">
                <p>Auara</p>
              </div>
              <div class="td">
                <p>Marruecos</p>
              </div>
              <div class="td">
                <p>2024</p>
              </div>
              <div class="td">
                <p>1.200</p>
              </div>
            </div>
            <div class="tr">
              <div class="td">
                <p>Acceso a sistema de agua potable y saneamiento a 80 hogares de Davao de Oro y Davao Oriental</p>
              </div>
              <div class="td">
                <p>Cáritas</p>
              </div>
              <div class="td">
                <p>Filipinas</p>
              </div>
              <div class="td">
                <p>2024</p>
              </div>
              <div class="td">
                <p>400</p>
              </div>
            </div>
            <div class="tr">
              <div class="td">
                <p>3 pozos: dos pozos en Chicote y uno en Lumbala Nguimbo</p>
              </div>
              <div class="td">
                <p>Jóvenes y Desarrollo</p>
              </div>
              <div class="td">
                <p>Angola</p>
              </div>
              <div class="td">
                <p>2024</p>
              </div>
              <div class="td">
                <p>5.000</p>
              </div>
            </div>
            <div class="tr">
              <div class="td">
                <p>3 bombas de agua y 50 letrinas en Sitios Kanada, Dubai y Saranay</p>
              </div>
              <div class="td">
                <p>Cáritas</p>
              </div>
              <div class="td">
                <p>Filipinas</p>
              </div>
              <div class="td">
                <p>2023</p>
              </div>
              <div class="td">
                <p>410</p>
              </div>
            </div>
            <div class="tr">
              <div class="td">
                <p>Rehabilitar 2 pozos + depósitos y saneamientos en escuelas de Luena</p>
              </div>
              <div class="td">
                <p>Auara</p>
              </div>
              <div class="td">
                <p>Angola</p>
              </div>
              <div class="td">
                <p>2023</p>
              </div>
              <div class="td">
                <p>4.269</p>
              </div>
            </div>
            <div class="tr">
              <div class="td">
                <p>Pozo, depósito y canalización en aldea de AitAninas</p>
              </div>
              <div class="td">
                <p>Auara</p>
              </div>
              <div class="td">
                <p>Marruecos</p>
              </div>
              <div class="td">
                <p>2022</p>
              </div>
              <div class="td">
                <p>350</p>
              </div>
            </div>
            <template v-if="openProyects == true">
              <div class="tr">
                <div class="td">
                  <p>Pozo con depósito y bomba solar en Guiua</p>
                </div>
                <div class="td">
                  <p>Cáritas</p>
                </div>
                <div class="td">
                  <p>Mozambique</p>
                </div>
                <div class="td">
                  <p>2022</p>
                </div>
                <div class="td">
                  <p>7.500</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>Agua potable para 2 sculeas en Ludewa</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>Tanzania</p>
                </div>
                <div class="td">
                  <p>2022</p>
                </div>
                <div class="td">
                  <p>750</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>2 pozos en escuelas de Huambo (Fase IV)</p>
                </div>
                <div class="td">
                  <p>Word Vision</p>
                </div>
                <div class="td">
                  <p>Angola</p>
                </div>
                <div class="td">
                  <p>2022</p>
                </div>
                <div class="td">
                  <p>2.000</p>
                </div>
              </div>

              <div class="tr">
                <div class="td">
                  <p>2 pozos en escuelas de Huambo (Fase III)</p>
                </div>
                <div class="td">
                  <p>Word Vision</p>
                </div>
                <div class="td">
                  <p>Angola</p>
                </div>
                <div class="td">
                  <p>2021</p>
                </div>
                <div class="td">
                  <p>850</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>Tanques de agua en 4 escuelas en Tanzania</p>
                </div>
                <div class="td">
                  <p>Aura</p>
                </div>
                <div class="td">
                  <p>Tanzania</p>
                </div>
                <div class="td">
                  <p>2021</p>
                </div>
                <div class="td">
                  <p>1.500</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>Pozo con déposito en Jao Kunda</p>
                </div>
                <div class="td">
                  <p>Aura</p>
                </div>
                <div class="td">
                  <p>Gambia</p>
                </div>
                <div class="td">
                  <p>2021</p>
                </div>
                <div class="td">
                  <p>900</p>
                </div>
              </div>

              <div class="tr">
                <div class="td">
                  <p>Pozo en Bifolon</p>
                </div>
                <div class="td">
                  <p>Aura</p>
                </div>
                <div class="td">
                  <p>Camerún</p>
                </div>
                <div class="td">
                  <p>2021</p>
                </div>
                <div class="td">
                  <p>460</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>10 dépositos en Ducrabon</p>
                </div>
                <div class="td">
                  <p>Aura</p>
                </div>
                <div class="td">
                  <p>Haití</p>
                </div>
                <div class="td">
                  <p>2021</p>
                </div>
                <div class="td">
                  <p>2.500</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>Pozo y tanque de agua en escuela de Metoro</p>
                </div>
                <div class="td">
                  <p>Cáritas</p>
                </div>
                <div class="td">
                  <p>Mozambique</p>
                </div>
                <div class="td">
                  <p>2021</p>
                </div>
                <div class="td">
                  <p>312</p>
                </div>
              </div>

              <div class="tr">
                <div class="td">
                  <p>Tanque en colegio de Ketama</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>Kenia</p>
                </div>
                <div class="td">
                  <p>2020</p>
                </div>
                <div class="td">
                  <p>402</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>Abastecimiento agua en Dzaleka</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>Malagui</p>
                </div>
                <div class="td">
                  <p>2020</p>
                </div>
                <div class="td">
                  <p>2.500</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>Pozo en Igli</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>Marruecos</p>
                </div>
                <div class="td">
                  <p>2020</p>
                </div>
                <div class="td">
                  <p>800</p>
                </div>
              </div>


              <div class="tr">
                <div class="td">
                  <p>Pozo en Bengbis</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>Camerún</p>
                </div>
                <div class="td">
                  <p>2020</p>
                </div>
                <div class="td">
                  <p>2.500</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>Pozo de agua Bio Sika Kparou</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>Benín</p>
                </div>
                <div class="td">
                  <p>2020</p>
                </div>
                <div class="td">
                  <p>250</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>Purificadora de agua en coletio St. Ignatius</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>India</p>
                </div>
                <div class="td">
                  <p>2020</p>
                </div>
                <div class="td">
                  <p>490</p>
                </div>
              </div>

              <div class="tr">
                <div class="td">
                  <p>Redes de saneamiento agua en escuelas de Huambo (Fase I)</p>
                </div>
                <div class="td">
                  <p>Word Vision</p>
                </div>
                <div class="td">
                  <p>Angola</p>
                </div>
                <div class="td">
                  <p>2020</p>
                </div>
                <div class="td">
                  <p>5.643</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>3 pozo de agua en Bongor y Gounou-Gaya</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>Chad</p>
                </div>
                <div class="td">
                  <p>2019</p>
                </div>
                <div class="td">
                  <p>977</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>1 Construcción de depósito de agua en Kivu</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>RD Congo</p>
                </div>
                <div class="td">
                  <p>2019</p>
                </div>
                <div class="td">
                  <p>2.500</p>
                </div>
              </div>


              <div class="tr">
                <div class="td">
                  <p>6 pozos de agua en Tamil Nadu</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>India</p>
                </div>
                <div class="td">
                  <p>2019</p>
                </div>
                <div class="td">
                  <p>5.000</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>5 tanques para recoger agua de lluvias en Villa Gonzalo</p>
                </div>
                <div class="td">
                  <p>Auara</p>
                </div>
                <div class="td">
                  <p>Perú</p>
                </div>
                <div class="td">
                  <p>2019</p>
                </div>
                <div class="td">
                  <p>266</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>3 Pozos de agua en escuelas de Huambo (Fase I)</p>
                </div>
                <div class="td">
                  <p>World Vision</p>
                </div>
                <div class="td">
                  <p>Angola</p>
                </div>
                <div class="td">
                  <p>2019</p>
                </div>
                <div class="td">
                  <p>6.587</p>
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  <p>2 pozos de agua en escuelas de Comin Yanga</p>
                </div>
                <div class="td">
                  <p>Yamlaminim</p>
                </div>
                <div class="td">
                  <p>Burkina Fasso</p>
                </div>
                <div class="td">
                  <p>2018</p>
                </div>
                <div class="td">
                  <p>400</p>
                </div>
              </div>
            </template>
          </div>
          <div class="row-start">
            <button class="more-proyects" @click="moreProyect()">{{textMoreProyects}}</button>
          </div>
        </div>
      </section>
      <div class="cuerpos-descargas container row-center -proyectos ais">

        <h2>Colaboradores</h2>

        <div class="cuerpo-descarga">
          <div class="contenedor-imagen">
            <img src="/static/img/logo-auara.png" alt="Logo AUARA">
          </div>
          <p>Empresa social que se dedica a luchar contra la falta de agua potable en países en vías de desarrollo.</p>
        </div>
        <div class="cuerpo-descarga">
          <div class="contenedor-imagen row-center">
            <img src="/static/img/logo-caritas.png" alt="Logo Caritas">
          </div>
          <p>Confederación oficial de entidades de acción caritativa y social de la Iglesia católica.</p>
        </div>
        <div class="cuerpo-descarga">
          <div class="contenedor-imagen row-center">
            <img src="/static/img/jovenes-desarrollo.png" alt="Logo Jóvenes y Desarrollo">
          </div>
          <p>Es una Organización No Gubernamental Salesiana sin ánimo de lucro. Su finalidad principal es cooperar por un desarrollo sostenible, humano, social y económico que contribuya a la erradicación de la pobreza en el mundo.</p>
        </div>
        <div class="cuerpo-descarga">
          <div class="contenedor-imagen row-center">
            <img src="/static/img/logo-world-vision.png" alt="Logo World vision">
          </div>
          <p>ONG cristiana de desarrollo, ayuda humanitaria y promoción de la justicia que trabaja desde 1950 con las
            comunidades más desfavorecidas para luchar contra la pobreza y conseguir un desarrollo sostenible.</p>
        </div>
        <div class="cuerpo-descarga">
          <div class="contenedor-imagen row-center">
            <img src="/static/img/yamlamininm.png" alt="Logo Yamlamininm">
          </div>
          <p>Tiene por objetivo desarrollar proyectos en Burkina Faso para mejorar las estructuras básicas de servicios a la población, como el acceso al agua, y cooperación en el terreno educativo y sanitario.</p>
        </div>
      </div>

      <section class="colabora">
        <div class="container row-center ais">
          <h2 class="big-title left">Colabora</h2>
          <h3 class="title-intro">
            ¿Te animas a <strong>colaborar</strong>?
          </h3>
          <div class="red-border-box">
            <h3 class="title-intro">
              ¿Como puedes <strong>colaborar</strong>?
            </h3>
          </div>
          <div class="texto column-start">
            <p><strong>Puedes colaborar con una pequeña donación que emplearemos en seguir acercando el agua a aquellos
                que más lo necesitan. </strong></p>
            <p>La Fundación Tomás Pascual y Pilar Gómez Cuétara está actualmente trabajando en N proyectos en distintos
              puntos del mundo. ¿Nos ayudas a hacer más?</p>
            <router-link :to="$t('enlaces.colabora')" class="btn red">Dona</router-link>
          </div>
        </div>
      </section>

      <proyectos-finalizados></proyectos-finalizados>

    </main>

  </div>

</template>

<script lang="js">
  import mapAgua from '@/components/parts/map-agua';
  import proyectosfinalizados from '@/components/parts/projects-finalizados';
  import { Carousel, Slide } from 'vue-carousel';

  export default {
    name: 'agua-para-todos',
    data: () => ({
      perPage: 4,
      openProyects: false,
      textMoreProyects: '+'
    }),
    mounted() {
      console.log(screen.width)
      if (screen.width <= 768) {
        this.perPage = 3
      }
      if (screen.width <= 480) {
        this.perPage = 1

      }
    },
    methods: {
      moreProyect() {
        this.openProyects = !this.openProyects
        if (this.textMoreProyects = '+') {
          this.textMoreProyects = '-'
        } else {
          this.textMoreProyects = '+'
        }
      }
    },
    components: {
      'proyectos-finalizados': proyectosfinalizados,
      'mapAgua': mapAgua,
      Carousel,
      Slide
    }
  }
</script>


<style lang="scss" scoped>
  @import '@/assets/css/colors.scss';

  .cuerpos-descargas {
    h2 {
      width: 100%;
      display: inline-block;
      font-family: "Conv_Museo 500";
      color: $gray;
      font-size: 36px;
      margin-bottom: 50px;
    }
  }

  .cuerpo-descarga .contenedor-imagen {
    min-height: 114px;
  }


  @media screen and (max-width: 500px) {

    .cuerpos-descargas h2 {
      margin-bottom: 20px;
      text-align: center;
    }

    .alcance .paises article {
      width: 100%;
    }

    .VueCarousel {

      width: 300px;
    }
  }

  .app,
  #app {
    overflow-x: hidden
  }
</style>


// WEBPACK FOOTER //
// src/components/views/agua-para-todos.vue